export const hiddenValue = "[undefiniert]";

export function display(value: String | Number): boolean {
  if (typeof value === "string") {
    return value !== hiddenValue;
  }

  return value !== -1;
}
